import { NgModule } from '@angular/core';
import { AuthComponent } from './auth.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from './auth.service';
import { routing } from './auth-routing.module';
import { LoginModule } from './login/login.module';
import { SignupComponent } from './signup/signup.component';
import { SharedModule } from '../shared/shared.module';
import { MatSlideToggleModule } from '@angular/material';
// import { NgSelectModule } from '@ng-select/ng-select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgOtpInputModule } from  'ng-otp-input';
import { ImageCropperModule } from "ngx-image-cropper";
import { CommonService } from '../shared/common.service';
@NgModule({
  imports: [NgOtpInputModule,LoginModule, ImageCropperModule,routing,MatSlideToggleModule,MatCheckboxModule, FormsModule,SharedModule, ReactiveFormsModule],
  declarations: [AuthComponent,SignupComponent],
  providers: [AuthService,CommonService]
})
export class AuthModule { }
